import { create } from 'zustand'

export const useTokenStore = create((set) => ({
  tokenData: {
    creditsUsed: 0,
    creditLimit: 0,
    extraCredits: 0,
    totalCredits: 0,
    renewalDate: ''
  },
  setTokenData: (data) => set({ tokenData: data }),
}))
